<template>
  <div
      class="mt-4 rounded border border-[#8CB3ED] bg-[#F0F3FF] p-4 text-center text-[15px]"
      v-if="nextDiscountTier"
  >
    <div
        v-if="nextDiscountTier === 'max_discount'"
        class="mb-2 font-semibold"
    >
      You are receiving a 50% discount on this purchase &#127881;
    </div>
    <div v-else class="mb-2">
      Add
      <span class="font-semibold">{{ nextDiscountTier.qty }}</span>
      more memberships to your cart and receive a bulk
      discount&nbsp;of&nbsp;<span class="font-semibold"
    >{{ nextDiscountTier.discountPercent }}%</span
    >
    </div>

    <Tooltip
        open-from="bottom-center"
        :width-px="300"
        css-classes="bg-white drop-shadow-md text-left rounded p-4 border border-gray-400 text-[15px]"
    >
      <template #trigger>
        <span class="text-blue-300 underline decoration-dotted"
        >See all bulk discounts</span
        >
      </template>
      <template #content>
        <div class="mb-2 font-semibold">Available Discounts</div>
        <div class="flex flex-col">
          <div class="grid grid-cols-2 gap-4 p-2">
            <div class="font-semibold text-gray-650">
              # Memberships
            </div>
            <div class="font-semibold text-gray-650">
              Bulk Discount
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 bg-gray-100 p-2">
            <div class="">5-10</div>
            <div class="">10%</div>
          </div>
          <div class="grid grid-cols-2 gap-4 p-2">
            <div class="">11-25</div>
            <div class="">20%</div>
          </div>
          <div class="grid grid-cols-2 gap-4 bg-gray-100 p-2">
            <div class="">26-50</div>
            <div class="">30%</div>
          </div>
          <div class="grid grid-cols-2 gap-4 p-2">
            <div class="">51-99</div>
            <div class="">40%</div>
          </div>
          <div class="grid grid-cols-2 gap-4 bg-gray-100 p-2">
            <div class="">100+</div>
            <div class="">50%</div>
          </div>
        </div>
      </template>
    </Tooltip>
  </div>
</template>
<script>
import Tooltip from "@/Components/Tooltip"

export default {
  name: 'GroupMembershipsDiscountNotice',
  components: {Tooltip},
  props: {
    nextDiscountTier: {}
  }
}
</script>
<style scoped lang="css">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>